/* eslint-disable prefer-destructuring */

import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ViewerProvider, actions } from '@store/viewerModule/base';
import usePageTitle from '@src/hooks/usePageTitle';
import { sharingResponseSelector } from '@store/viewerModule/sharing/selectors';
import { dashboardResponseSelector } from '@store/viewerModule/dashboard/selectors';
import { allTrafficFilterSelector } from '@store/filterContainer/selectors';
import { PAGE_TYPE } from '@utils/constants';
import Content from './Content';
import TopPanel from './TopPanel';
import { Wrapper } from './styled';

const ViewerModulePage = (props) => {
  const { pageType } = props;
  const reduxDispatch = useDispatch();
  const { viewerId } = useParams<{ viewerId: string }>();
  const { id = `vm-${viewerId}` } = useParams<{ id?: string }>();
  const { fid } = useSelector(allTrafficFilterSelector) || { fid: null };
  const response = useSelector(sharingResponseSelector);
  const dashboardResponse = useSelector(dashboardResponseSelector);

  usePageTitle({ text: viewerId ? `Viewer - ${viewerId}` : 'Viewers' });

  const initValues: Record<string, any> = {
    id,
    viewerId,
    filterId: fid,
    pageType,
  };

  const vmStore = (() => {
    if (pageType === PAGE_TYPE.SHARING) {
      return response?.state.vmStore;
    } else if (pageType === PAGE_TYPE.SAVED_DASHBOARD) {
      return dashboardResponse.config.vmStore;
    }
  })();

  if (vmStore) {
    initValues.viewerId = vmStore.viewerId;
    initValues.interval = vmStore.interval;
    const { selectedColumns = [] } = vmStore;

    if (Array.isArray(selectedColumns)) {
      initValues.selectedColumns = selectedColumns.map((it) => ({
        metric: it,
        show: true,
      }));
    }
  }

  // Update redux store with selected columns, only for saved dashboard and sharing page
  React.useEffect(() => {
    if (
      [PAGE_TYPE.SAVED_DASHBOARD, PAGE_TYPE.SHARING].includes(pageType) &&
      initValues.selectedColumns?.length
    ) {
      reduxDispatch(
        actions.setSelectedColumns({
          selectedColumns: initValues.selectedColumns,
          notUpdatePersistence: true,
        }),
      );
    }
  }, [reduxDispatch, initValues.selectedColumns, pageType]);

  return (
    <React.Fragment key={`${viewerId}-${id}`}>
      <ViewerProvider initValues={initValues}>
        <Wrapper>
          <TopPanel id={id} pageType={pageType} />
          <Content />
        </Wrapper>
      </ViewerProvider>
    </React.Fragment>
  );
};

export default ViewerModulePage;
